const footerLinks = [
  {
    id: "nav",
    title: "站内导航",
    links: [
      { id: "f-cases", label: "实锤汇总", href: "#cases" },
      { id: "f-entries", label: "类型入口", href: "#entries" },
      { id: "f-timeline", label: "线索时间线", href: "#timeline" },
      { id: "f-files", label: "材料下载", href: "#files" },
    ],
  },
  {
    id: "types",
    title: "材料类型",
    links: [
      { id: "f-shot", label: "截图证据", href: "#entries" },
      { id: "f-audio", label: "录音文件", href: "#entries" },
      { id: "f-doc", label: "文档材料", href: "#entries" },
      { id: "f-clue", label: "线索投稿", href: "#entries" },
    ],
  },
  {
    id: "more",
    title: "参与方式",
    links: [
      { id: "f-discuss", label: "讨论区", href: "#discuss" },
      { id: "f-topics", label: "正在热议", href: "#discuss" },
      { id: "f-tags", label: "关键词索引", href: "#tags" },
      { id: "f-feed", label: "最新快讯", href: "#flash" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-bookmark-3-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold">海角黑料</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              汇总海角黑料实锤证据，包括截图、录音、文件等关键材料。想找海角黑料证据、核对线索细节，这里集中整理各方实锤内容，供你对比讨论。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-md bg-background-50/10 px-3 py-2 text-xs text-background-200">
              <i className="ri-refresh-line"></i>
              线索细节持续更新 · 最近整理 2026-09-10
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.id} className="lg:col-span-2">
              <h3 className="font-heading text-sm font-bold text-background-100">{group.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="cursor-pointer whitespace-nowrap text-sm text-background-300 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-9 border-t border-background-50/15 pt-6">
          <p className="text-xs leading-relaxed text-background-300">
            本站为内容整理与线索讨论页面，所展示材料均标注来源与时间，仅供比对与讨论使用；如对内容有异议，可通过讨论区反馈，我们会按流程复核。
          </p>
          <div className="mt-5 flex flex-col gap-3 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
            <span>© 2026 海角黑料 · 实锤证据汇总站 · 内容持续更新</span>
            <div className="flex flex-wrap gap-5">
              <a
                href="#top"
                className="cursor-pointer whitespace-nowrap transition-colors hover:text-accent-300"
              >
                返回顶部
              </a>
              <a
                href="#discuss"
                className="cursor-pointer whitespace-nowrap transition-colors hover:text-accent-300"
              >
                反馈与投稿
              </a>
              <a
                href="#tags"
                className="cursor-pointer whitespace-nowrap transition-colors hover:text-accent-300"
              >
                关键词索引
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}